import React from 'react';
import './ExerciseSteps.css';

const ActionStep = ({ step, onContinue }) => {
  return (
    <div className="step-container">
      <div className="step-content">
        <h2 className="step-title">{step.title}</h2>
        <div className="step-text action-text">
          {step.content}
        </div>
        <div className="action-icon">
          <span role="img" aria-label="action">🎯</span>
        </div>
      </div>
      <div className="step-actions">
        <button 
          className="step-button primary"
          onClick={onContinue}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default ActionStep; 